import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const BusinessContext = createContext(null);

export function BusinessProvider({ children }) {
  const { user } = useAuth();
  const [businesses, setBusinesses] = useState([]);
  const [activeId, setActiveId] = useState(localStorage.getItem("ezdox_business") || null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/businesses");
      setBusinesses(data);
      let active = localStorage.getItem("ezdox_business");
      if (!active || !data.find((b) => b.id === active)) {
        active = data[0]?.id || null;
        if (active) localStorage.setItem("ezdox_business", active);
      }
      setActiveId(active);
    } catch { /* ignore */ }
    finally { setLoading(false); }
  }, []);

  useEffect(() => {
    if (user && user !== false) load();
    else if (user === false) { setBusinesses([]); setLoading(false); }
  }, [user, load]);

  const switchBusiness = (id) => {
    localStorage.setItem("ezdox_business", id);
    window.location.reload();
  };

  const active = businesses.find((b) => b.id === activeId) || businesses[0] || null;

  return (
    <BusinessContext.Provider value={{ businesses, active, activeId, switchBusiness, reload: load, loading }}>
      {children}
    </BusinessContext.Provider>
  );
}

export const useBusiness = () => useContext(BusinessContext);
